export const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};
